<template>
  <div style="height: 100%; overflow-y: auto !important;">
    <template v-if="!loading">
      <template v-if="items.length > 0">
        <as-latest-list-item :items="items" />
      </template>
      <template v-else>
        <no-items
          :title="'A/S 내역이 없습니다' | translate"
        />
      </template>
    </template>
    <template v-else>
      <div style="display: flex; align-items: center; justify-content: center; height: 100%; width: 100%;">
        <progress-loading />
      </div>
    </template>
  </div>
</template>

<script>
    import {PATH} from "@/constants";
    import NoItems from "@/components/items/NoItems";
    import Work from "@/model/work";
    import AsLatestListItem from "@/components/items/as/AsLatestListItem";
    import ProgressLoading from "@/components/part/ProgressLoading";

    export default {
        name: "AsLatestTabsItems",
        components: {ProgressLoading, AsLatestListItem, NoItems},
        props: {
            accountId: undefined,
            workorderId: undefined,
            changeId: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                loading: false,
                items: [],
            }
        },
        watch: {
            changeId() {
                this.loadRecentAsHistory();
            },
        },
        created() {
            this.loadRecentAsHistory();
        },
        methods: {
            async loadRecentAsHistory(loading = true) {
                if (!this.accountId) return;
                if (this.loading) return;
                this.loading = loading;
                try {
                    const response = await this.$request(PATH.WORK_ORDER.AS_LAST_AS_HISTORY)
                        .setObject({
                            accountId: this.accountId,
                            workorderId: this.workorderId,
                        })
                        .wait(500)
                        .enqueue();
                    this.items = response.data.map(item => new Work(item));
                } catch (error) {
                    console.error(error);
                }
                this.loading = false;
            },
        },
    }
</script>

<style scoped>

</style>